module.exports = __webpack_public_path__ + "img/04_mzste8_c_scale,w_1400.b83be279.jpg";